import { Buffer } from "buffer";
import { v4 as uuidv4 } from "uuid";
import { producaov2 } from "../services/apis";

export const formatDate = (dateString, formatPattern = "dd/MM/yyyy HH:mm") => {
  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "-";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    if (formatPattern === "dd/MM/yyyy HH:mm") {
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
    return `${day}/${month}/${year}`;
  } catch (e) {
    console.error("Erro ao formatar data:", e);
    return "-";
  }
};

export const validadeWithDataPcoAndValueCurso = (pco, valor_curso) => {
  const { data_inicio, validade, data_insert } = pco;
  let expirado = false;

  let data_final = data_inicio;
  if (data_inicio.split("-")[0] === "0000") {
    data_final = data_insert;
  }
  let validade_final = parseInt(validade);

  //Verificando se o curso foi pago
  if (validade_final != 180) {
    // Verificação para saber se o curso é vitalício (validade = 180) e se ele já foi iniciado. Se um dos dois for vertdade, não faz a verificação da possibilidade de renovação do curso
    let hoje = new Date();
    let vencimento = new Date(data_final);
    vencimento.setDate(vencimento.getDate() + validade_final);
    if (hoje > vencimento) {
      // E se o curso for gratuito
      if (valor_curso == 0) {
        expirado = false;
      } else {
        //Caso seja um curso pago
        expirado = true;
      }
    }
  }
  return expirado;
};

export const initJivoChat = () => {
  var widget_id = "pQmM0T1v22";
  var d = document;
  var w = window;
  function l() {
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "//code.jivosite.com/script/widget/" + widget_id;
    var ss = document.getElementsByTagName("script")[0];
    ss.parentNode.insertBefore(s, ss);
  }

  if (d.readyState == "complete") {
    l();
  } else {
    if (w.attachEvent) {
      w.attachEvent("onload", l);
    } else {
      w.addEventListener("load", l, false);
    }
  }
};

export const animate = (elem, style, unit, from, to, time, prop) => {
  if (!elem) {
    return;
  }
  var start = new Date().getTime(),
    timer = setInterval(function () {
      var step = Math.min(1, (new Date().getTime() - start) / time);
      if (prop) {
        elem[style] = from + step * (to - from) + unit;
      } else {
        elem.style[style] = from + step * (to - from) + unit;
      }
      if (step === 1) {
        clearInterval(timer);
      }
    }, 25);
  if (prop) {
    elem[style] = from + unit;
  } else {
    elem.style[style] = from + unit;
  }
};

export const verify_mobile = () => {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i) ||
    window.innerWidth < 762
  ) {
    return true;
  } else {
    return false;
  }
};

export const smallDateFormat = (date) => {
  const newDate = new Date(date);
  const day = newDate.getDate().toString();
  const dayF = day.length === 1 ? "0" + day : day;
  const month = (newDate.getMonth() + 1).toString();
  const monthF = month.length === 1 ? "0" + month : month;
  const yearF = newDate.getFullYear();
  return dayF + "/" + monthF + "/" + yearF;
};

export const smallDateFormatWithTime = (date) => {
  const newDate = new Date(date);
  const day = newDate.getDate().toString().padStart(2, "0");
  const month = (newDate.getMonth() + 1).toString().padStart(2, "0");
  const year = newDate.getFullYear().toString();
  const hours = newDate.getHours().toString().padStart(2, "0");
  const minutes = newDate.getMinutes().toString().padStart(2, "0");
  const seconds = newDate.getSeconds().toString().padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

export const smallDateFormatWithTimeResetUTC = (date) => {
  if (!date) return "";

  // Dividimos a data no formato ISO
  const [datePart, timePart] = date.split("T");

  // Verificamos se o formato é válido
  if (!datePart || !timePart) return "";

  // Extraímos ano, mês e dia
  const [year, month, day] = datePart.split("-");

  // Extraímos horas, minutos e segundos (ignorando a parte de milissegundos e o Z)
  const [hours, minutes, seconds] = timePart.split(":");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds.split(".")[0]}`;
};

function transformToAssocArray(prmstr) {
  var params = {};
  var prmarr = prmstr.split("&");
  for (var i = 0; i < prmarr.length; i++) {
    var tmparr = prmarr[i].split("=");
    params[tmparr[0]] = tmparr[1];
  }
  return params;
}

export const getSearchParameters = (url) => {
  var prmstr = url.substr(1);
  return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
};

export const encode_utf8 = (html) => {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

export const formataDescricao = (desc, qtdPalavras = 85, curso = false) => {
  desc = cleanTagsHtml(desc);
  if (curso) {
    var descFormatada = desc.substr(0, qtdPalavras) + "...";
  } else {
    var descFormatada = desc.substr(0, qtdPalavras) + "...";
  }
  descFormatada = descFormatada.replace("", "");
  return encode_utf8(descFormatada);
};

export const tempoDeLeitura = (desc) => {
  /* Tempo de leitura do artigo */
  var str = cleanTagsHtml(desc);
  var int = parseInt(contarpalavra(str) / 169); // dividi por 169 para ficar mesmo tempo do que a função similar em php
  var text = int > 1 ? " mins de leitura" : " min de leitura";
  var tempo = int + text;
  return tempo;
};

export const cleanTagsHtml = (str) => {
  var nova_string = str.replace(/<\/?[^>]+>/gi, "");
  return nova_string;
};

export const contarpalavra = (valor) => {
  valor.replace(/(\r\n|\n|\r)/g, " ");
  var cont = valor.split(/\s+/g).length;
  return cont;
};

export const retornaUrlImgs = (url, tipo, size = "320") => {
  var result = "";
  switch (tipo) {
    case "blog":
      url = url.replace("https://www.voitto.com.br/", "");
      if (url.search("png") > -1) {
        url += "?size=" + size;
      }
      result = "https://www.voitto.com.br/" + url;
      break;
    case "curso":
      result =
        "https://files.voitto.com.br/cursos/small/" + url + ".jpg";
    default:
      break;
  }
  return result;
};

export const authorizationGen = () => {
  let gen = new Date().getTime() / 1000;
  return window.btoa(gen.toFixed(0));
};

export const abrevia_nome = (str) => {
  const nome = str.replace(/\s+/gi, " ").trim();
  var array_nome = nome.split(" ");
  if (array_nome.length > 1) {
    return array_nome
      .map((parte, index, nomes) => (index != 1 ? parte : `${parte[0]}.`))
      .join(" ");
  } else {
    return str.substr(0, 15) + "...";
  }
};

export const valid_img = (img) => {
  if (img.indexOf("https://") <= -1) {
    return "https://voitto.com.br/" + img;
  } else {
    return img;
  }
};

export const retira_acentos = (str) => {
  let com_acento =
    "ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ";

  let sem_acento =
    "AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr";
  let novastr = "";
  for (var i = 0; i < str.length; i++) {
    var troca = false;
    for (var a = 0; a < com_acento.length; a++) {
      if (str.substr(i, 1) == com_acento.substr(a, 1)) {
        novastr += sem_acento.substr(a, 1);
        troca = true;
        break;
      }
    }
    if (troca == false) {
      novastr += str.substr(i, 1);
    }
  }
  return novastr;
};

export const convertDate = (inputFormat) => {
  function pad(s) {
    return s < 10 ? "0" + s : s;
  }
  var d = new Date(inputFormat);
  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join("/");
};

export const salvarRelatorio = (btn, table, label) => {
  var date = new Date();
  date =
    date.getDate() +
    "-" +
    date.getMonth() +
    "-" +
    date.getFullYear() +
    " " +
    date.getHours() +
    "h" +
    date.getMinutes() +
    "m" +
    date.getSeconds() +
    "s";

  var a = document.createElement("a");
  a.setAttribute("href", fnExcelReport(table, 1));
  a.setAttribute("download", label + " " + date + ".xls");
  a.click();
  //'use strict';
  a = null;
};

export const fnExcelReport = (tab, mode) => {
  var tab_text = "<table border='2px'><tr>";
  var textRange;
  var j = 0;
  var txtArea1 = document.getElementById("txtArea1");
  var sa = "";
  for (j = 0; j < tab.rows.length; j++) {
    if (tab.rows[j].style.display != "none")
      tab_text = tab_text + tab.rows[j].innerHTML + "</tr>";
  }

  tab_text = tab_text + "</table>";
  //tab_text= tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
  //tab_text= tab_text.replace(/<img[^>]*>/gi,""); // remove if u want images in your table
  tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params
  tab_text = tab_text.replace(
    new RegExp("Baixar Certificado", "g"),
    "Curso concluído",
  );
  tab_text = tab_text.replace(
    new RegExp("Gerar Certificado", "g"),
    "Curso não concluído",
  );

  tab_text = tab_text.TextEncode("UTF-8", "WINDOWS-1252");
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    // If Internet Explorer
    txtArea1.document.open("txt/html", "replace");
    txtArea1.document.write(tab_text);
    txtArea1.document.close();
    txtArea1.focus();
    sa = txtArea1.document.execCommand(
      "SaveAs",
      true,
      "Relatorios de Alunos - Painel Empresa Grupo Voitto.xls",
    );
  } else {
    //other browser not tested on IE 11
    if (mode == 1) {
      return "data:application/vnd.ms-excel;base64," + btoa(tab_text);
    } else {
      sa = window.open(
        "data:application/vnd.ms-excel;base64," + btoa(tab_text),
      );
      return sa;
    }
  }
};

export const verificaTamanho_img = (url) => {
  const newImg = new Image();
  return new Promise((res, rej) => {
    newImg.onload = function () {
      const height = newImg.height;
      const width = newImg.width;
      res({
        altura: newImg.width,
        largura: newImg.height,
      });
    };
    newImg.src = url;
  });
};

export const padraoLogo = async (img_url, height) => {
  let tam_img = await verificaTamanho_img(img_url).then((size) => {
    let img = size;
    let perHeight = ((img.altura - height) / img.altura) * 100;
    let width = img.largura - img.largura * (perHeight / 100);
    return { width, height };
  });

  return tam_img;
};

export const retornaPrimeiroNome = (nome) => {
  if (nome == 0) return;
  let array_nome = nome.split(" ");
  return array_nome[0];
};

export const limpaTituloCurso = (titulo) => {
  if (!titulo) {
    return "";
  }

  let title = titulo;

  title = title.replace("ONLINE - ", "");
  title = title.replace("[GRATUITO]", "");
  title = title.replace("[COMBO]", "");
  title = title.replace("[CICLO DE MENTORIA]", "");
  title = title.replace("[POWER HACKS]", "");
  title = title.replace("[MASTER CLASS]", "");
  title = title.replace("[LETS GROW]", "");
  title = title.replace("AULA AO VIVO - ", "");
  title = title.replace("[DESMISTIFICANDO]", "");
  title = title.replace("[WORKSHOP]", "");
  title = title.replace(" TRUQUES DE EXCEL PARA PROCESSOS SELETIVOS -", "");
  title = title.replace(" MARKETING DIGITAL - ", "");
  title = title.replace(" MARKETING DE CONTEÚDO - ", "");
  title = title.replace(" BLACK BELT NA PRÁTICA - ", "");
  title = title.replace(" SCRUM PARA GERENCIAMENTO DE PROJETOS - ", "");
  title = title.replace(" INOVAÇÃO E DESIGN THINKING - ", "");
  title = title.replace(" GESTÃO FINANCEIRA - ", "");
  title = title.replace("[MUNDO EMPREENDEDOR] ", "");
  title = title.replace("[PAPO DE CONSULTOR] ", "");
  title = title.replace("[PAPO DE ESPECIALISTA] ", "");
  title = title.replace("[PASSO A PASSO] ", "");
  title = title.replace("[SOFT SKILLS] ", "");
  title = title.replace("[INDÚSTRIA 4.0] ", "");
  title = title.split("(");
  title = title[0];
  return title;
};

String.prototype.TextEncode = function (from, to) {
  from = from.toUpperCase();
  to = to.toUpperCase();
  var WINDOWS_1252 = [
    "\u0000",
    "\u0001",
    "\u0002",
    "\u0003",
    "\u0004",
    "\u0005",
    "\u0006",
    "\u0007",
    "\b",
    "\t",
    "\n",
    "\u000b",
    "\f",
    "\r",
    "\u000e",
    "\u000f",
    "\u0010",
    "\u0011",
    "\u0012",
    "\u0013",
    "\u0014",
    "\u0015",
    "\u0016",
    "\u0017",
    "\u0018",
    "\u0019",
    "\u001a",
    "\u001b",
    "\u001c",
    "\u001d",
    "\u001e",
    "\u001f",
    " ",
    "!",
    '"',
    "#",
    "$",
    "%",
    "&",
    "'",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "@",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "[",
    "\\",
    "]",
    "^",
    "_",
    "`",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "{",
    "|",
    "}",
    "~",
    "",
    "\u20AC",
    "?",
    "\u201A",
    "\u0192",
    "\u201E",
    "\u2026",
    "\u2020",
    "\u2021",
    "\u02C6",
    "\u2030",
    "\u0160",
    "\u2039",
    "\u0152",
    "?",
    "\u017D",
    "?",
    "?",
    "\u2018",
    "\u2019",
    "\u201C",
    "\u201D",
    "\u2022",
    "\u2013",
    "\u2014",
    "\u02DC",
    "\u2122",
    "\u0161",
    "\u203A",
    "\u0153",
    "",
    "\u017E",
    "\u0178",
    "\u00A0",
    "¡",
    "¢",
    "£",
    "¤",
    "¥",
    "¦",
    "§",
    "¨",
    "©",
    "ª",
    "«",
    "¬",
    "",
    "®",
    "¯",
    "°",
    "±",
    "²",
    "³",
    "´",
    "µ",
    "¶",
    "·",
    "¸",
    "¹",
    "º",
    "»",
    "¼",
    "½",
    "¾",
    "¿",
    "À",
    "Á",
    "Â",
    "Ã",
    "Ä",
    "Å",
    "Æ",
    "Ç",
    "È",
    "É",
    "Ê",
    "Ë",
    "Ì",
    "Í",
    "Î",
    "Ï",
    "Ð",
    "Ñ",
    "Ò",
    "Ó",
    "Ô",
    "Õ",
    "Ö",
    "×",
    "Ø",
    "Ù",
    "Ú",
    "Û",
    "Ü",
    "Ý",
    "Þ",
    "ß",
    "à",
    "á",
    "â",
    "ã",
    "ä",
    "å",
    "æ",
    "ç",
    "è",
    "é",
    "ê",
    "ë",
    "ì",
    "í",
    "î",
    "ï",
    "ð",
    "ñ",
    "ò",
    "ó",
    "ô",
    "õ",
    "ö",
    "÷",
    "ø",
    "ù",
    "ú",
    "û",
    "ü",
    "ý",
    "þ",
    "ÿ",
    "Œ",
    "œ",
    "Š",
    "š",
    "Ÿ",
    "Ž",
    "ž",
    "ƒ",
    "ˆ",
    "˜",
    "–",
    "—",
    "‘",
    "’",
    "‚",
    "“",
    "”",
    "„",
    "†",
    "‡",
    "•",
    "…",
    "‰",
    "‹",
    "›",
    "€",
    "™",
  ];
  var UTF_8 = [
    "\u0000",
    "\u0001",
    "\u0002",
    "\u0003",
    "\u0004",
    "\u0005",
    "\u0006",
    "\u0007",
    "\b",
    "\t",
    "\n",
    "\u000b",
    "\f",
    "\r",
    "\u000e",
    "\u000f",
    "\u0010",
    "\u0011",
    "\u0012",
    "\u0013",
    "\u0014",
    "\u0015",
    "\u0016",
    "\u0017",
    "\u0018",
    "\u0019",
    "\u001a",
    "\u001b",
    "\u001c",
    "\u001d",
    "\u001e",
    "\u001f",
    " ",
    "!",
    '"',
    "#",
    "$",
    "%",
    "&",
    "'",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "@",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "[",
    "\\",
    "]",
    "^",
    "_",
    "`",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "{",
    "|",
    "}",
    "~",
    "",
    "\u00e2\u201a\u00ac",
    "\u00ef\u00bf\u00bd",
    "\u00e2\u20ac\u0161",
    "\u00c6\u2019",
    "\u00e2\u20ac\u017e",
    "\u00e2\u20ac\u00a6",
    "\u00e2\u20ac\u00a0",
    "\u00e2\u20ac\u00a1",
    "\u00cb\u2020",
    "\u00e2\u20ac\u00b0",
    "\u00c5\u00a0",
    "\u00e2\u20ac\u00b9",
    "\u00c5\u2019",
    "\u00ef\u00bf\u00bd",
    "\u00c5\u00bd",
    "\u00ef\u00bf\u00bd",
    "\u00ef\u00bf\u00bd",
    "\u00e2\u20ac\u02dc",
    "\u00e2\u20ac\u2122",
    "\u00e2\u20ac\u0153",
    "\u00e2\u20ac\ufffe",
    "\u00e2\u20ac\u00a2",
    "\u00e2\u20ac\u201c",
    "\u00e2\u20ac\u201d",
    "\u00cb\u0153",
    "\u00e2\u201e\u00a2",
    "\u00c5\u00a1",
    "\u00e2\u20ac\u00ba",
    "\u00c5\u201c",
    "\u00ef\u00bf\u00bd",
    "\u00c5\u00be",
    "\u00c5\u00b8",
    "\u00c2\u00a0",
    "\u00c2\u00a1",
    "\u00c2\u00a2",
    "\u00c2\u00a3",
    "\u00c2\u00a4",
    "\u00c2\u00a5",
    "\u00c2\u00a6",
    "\u00c2\u00a7",
    "\u00c2\u00a8",
    "\u00c2\u00a9",
    "\u00c2\u00aa",
    "\u00c2\u00ab",
    "\u00c2\u00ac",
    "\u00c2\u00ad",
    "\u00c2\u00ae",
    "\u00c2\u00af",
    "\u00c2\u00b0",
    "\u00c2\u00b1",
    "\u00c2\u00b2",
    "\u00c2\u00b3",
    "\u00c2\u00b4",
    "\u00c2\u00b5",
    "\u00c2\u00b6",
    "\u00c2\u00b7",
    "\u00c2\u00b8",
    "\u00c2\u00b9",
    "\u00c2\u00ba",
    "\u00c2\u00bb",
    "\u00c2\u00bc",
    "\u00c2\u00bd",
    "\u00c2\u00be",
    "\u00c2\u00bf",
    "\u00c3\u20ac",
    "\u00c3\ufffe",
    "\u00c3\u201a",
    "\u00c3\u0192",
    "\u00c3\u201e",
    "\u00c3\u2026",
    "\u00c3\u2020",
    "\u00c3\u2021",
    "\u00c3\u02c6",
    "\u00c3\u2030",
    "\u00c3\u0160",
    "\u00c3\u2039",
    "\u00c3\u0152",
    "\u00c3\ufffe",
    "\u00c3\u017d",
    "\u00c3\ufffe",
    "\u00c3\ufffe",
    "\u00c3\u2018",
    "\u00c3\u2019",
    "\u00c3\u201c",
    "\u00c3\u201d",
    "\u00c3\u2022",
    "\u00c3\u2013",
    "\u00c3\u2014",
    "\u00c3\u02dc",
    "\u00c3\u2122",
    "\u00c3\u0161",
    "\u00c3\u203a",
    "\u00c3\u0153",
    "\u00c3\ufffe",
    "\u00c3\u017e",
    "\u00c3\u0178",
    "\u00c3\u00a0",
    "\u00c3\u00a1",
    "\u00c3\u00a2",
    "\u00c3\u00a3",
    "\u00c3\u00a4",
    "\u00c3\u00a5",
    "\u00c3\u00a6",
    "\u00c3\u00a7",
    "\u00c3\u00a8",
    "\u00c3\u00a9",
    "\u00c3\u00aa",
    "\u00c3\u00ab",
    "\u00c3\u00ac",
    "\u00c3\u00ad",
    "\u00c3\u00ae",
    "\u00c3\u00af",
    "\u00c3\u00b0",
    "\u00c3\u00b1",
    "\u00c3\u00b2",
    "\u00c3\u00b3",
    "\u00c3\u00b4",
    "\u00c3\u00b5",
    "\u00c3\u00b6",
    "\u00c3\u00b7",
    "\u00c3\u00b8",
    "\u00c3\u00b9",
    "\u00c3\u00ba",
    "\u00c3\u00bb",
    "\u00c3\u00bc",
    "\u00c3\u00bd",
    "\u00c3\u00be",
    "\u00c3\u00bf",
  ];
  var HTML_ENTITIES = [
    "\u0000",
    "\u0001",
    "\u0002",
    "\u0003",
    "\u0004",
    "\u0005",
    "\u0006",
    "\u0007",
    "\b",
    "\t",
    "\n",
    "\u000b",
    "\f",
    "\r",
    "\u000e",
    "\u000f",
    "\u0010",
    "\u0011",
    "\u0012",
    "\u0013",
    "\u0014",
    "\u0015",
    "\u0016",
    "\u0017",
    "\u0018",
    "\u0019",
    "\u001a",
    "\u001b",
    "\u001c",
    "\u001d",
    "\u001e",
    "\u001f",
    " ",
    "!",
    "&quot;",
    "#",
    "$",
    "%",
    "&amp;",
    "'",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ":",
    ";",
    "&lt;",
    "=",
    "&gt;",
    "?",
    "@",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "[",
    "\\",
    "]",
    "^",
    "_",
    "`",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "{",
    "|",
    "}",
    "~",
    "",
    "&euro;",
    "",
    "&sbquo;",
    "&fnof;",
    "&bdquo;",
    "&hellip;",
    "&dagger;",
    "&Dagger;",
    "&circ;",
    "&permil;",
    "&Scaron;",
    "&lsaquo;",
    "&OElig;",
    "",
    "\u017d",
    "",
    "",
    "&lsquo;",
    "&rsquo;",
    "&ldquo;",
    "&rdquo;",
    "&bull;",
    "&ndash;",
    "&mdash;",
    "&tilde;",
    "&trade;",
    "&scaron;",
    "&rsaquo;",
    "&oelig;",
    "",
    "\u017e",
    "&Yuml;",
    "&nbsp;",
    "&iexcl;",
    "&cent;",
    "&pound;",
    "&curren;",
    "&yen;",
    "&brvbar;",
    "&sect;",
    "&uml;",
    "&copy;",
    "&ordf;",
    "&laquo;",
    "&not;",
    "&shy;",
    "&reg;",
    "&macr;",
    "&deg;",
    "&plusmn;",
    "&sup2;",
    "&sup3;",
    "&acute;",
    "&micro;",
    "&para;",
    "&middot;",
    "&cedil;",
    "&sup1;",
    "&ordm;",
    "&raquo;",
    "&frac14;",
    "&frac12;",
    "&frac34;",
    "&iquest;",
    "&Agrave;",
    "&Aacute;",
    "&Acirc;",
    "&Atilde;",
    "&Auml;",
    "&Aring;",
    "&AElig;",
    "&Ccedil;",
    "&Egrave;",
    "&Eacute;",
    "&Ecirc;",
    "&Euml;",
    "&Igrave;",
    "&Iacute;",
    "&Icirc;",
    "&Iuml;",
    "&ETH;",
    "&Ntilde;",
    "&Ograve;",
    "&Oacute;",
    "&Ocirc;",
    "&Otilde;",
    "&Ouml;",
    "&times;",
    "&Oslash;",
    "&Ugrave;",
    "&Uacute;",
    "&Ucirc;",
    "&Uuml;",
    "&Yacute;",
    "&THORN;",
    "&szlig;",
    "&agrave;",
    "&aacute;",
    "&acirc;",
    "&atilde;",
    "&auml;",
    "&aring;",
    "&aelig;",
    "&ccedil;",
    "&egrave;",
    "&eacute;",
    "&ecirc;",
    "&euml;",
    "&igrave;",
    "&iacute;",
    "&icirc;",
    "&iuml;",
    "&eth;",
    "&ntilde;",
    "&ograve;",
    "&oacute;",
    "&ocirc;",
    "&otilde;",
    "&ouml;",
    "&divide;",
    "&oslash;",
    "&ugrave;",
    "&uacute;",
    "&ucirc;",
    "&uuml;",
    "&yacute;",
    "&thorn;",
    "&yuml;",
  ];
  var WEB_ENTITIES = [
    "\u0000",
    "\u0001",
    "\u0002",
    "\u0003",
    "\u0004",
    "\u0005",
    "\u0006",
    "\u0007",
    "\b",
    "	",
    " ",
    "\u000b",
    "",
    " ",
    "\u000e",
    "\u000f",
    "\u0010",
    "\u0011",
    "\u0012",
    "\u0013",
    "\u0014",
    "\u0015",
    "\u0016",
    "\u0017",
    "\u0018",
    "\u0019",
    "\u001a",
    "\u001b",
    "\u001c",
    "\u001d",
    "\u001e",
    "\u001f",
    " ",
    "!",
    '"',
    "#",
    "$",
    "%",
    "&",
    "'",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "@",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "[",
    "",
    "]",
    "^",
    "_",
    "`",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "{",
    "|",
    "}",
    "~",
    "",
    "€",
    "",
    "‚",
    "ƒ",
    "„",
    "…",
    "†",
    "‡",
    "ˆ",
    "‰",
    "Š",
    "‹",
    "Œ",
    "",
    "\u017d",
    "",
    "",
    "‘",
    "’",
    "“",
    "”",
    "•",
    "–",
    "—",
    "˜",
    "™",
    "š",
    "›",
    "œ",
    "",
    "\u017e",
    "Ÿ",
    " ",
    "¡",
    "¢",
    "£",
    "¤",
    "¥",
    "¦",
    "§",
    "¨",
    "©",
    "ª",
    "«",
    "¬",
    "­",
    "®",
    "¯",
    "°",
    "±",
    "²",
    "³",
    "´",
    "µ",
    "¶",
    "·",
    "¸",
    "¹",
    "º",
    "»",
    "¼",
    "½",
    "¾",
    "¿",
    "À",
    "Á",
    "Â",
    "Ã",
    "Ä",
    "Å",
    "Æ",
    "Ç",
    "È",
    "É",
    "Ê",
    "Ë",
    "Ì",
    "Í",
    "Î",
    "Ï",
    "Ð",
    "Ñ",
    "Ò",
    "Ó",
    "Ô",
    "Õ",
    "Ö",
    "×",
    "Ø",
    "Ù",
    "Ú",
    "Û",
    "Ü",
    "Ý",
    "Þ",
    "ß",
    "à",
    "á",
    "â",
    "ã",
    "ä",
    "å",
    "æ",
    "ç",
    "è",
    "é",
    "ê",
    "ë",
    "ì",
    "í",
    "î",
    "ï",
    "ð",
    "ñ",
    "ò",
    "ó",
    "ô",
    "õ",
    "ö",
    "÷",
    "ø",
    "ù",
    "ú",
    "û",
    "ü",
    "ý",
    "þ",
    "ÿ",
  ];
  var str = this;
  var text = "";

  if (from == "HTML_ENTITIES") {
    text = str;
    for (var c = 128; c < HTML_ENTITIES.length; c++) {
      text = text.replace(new RegExp(HTML_ENTITIES[c], "g"), WEB_ENTITIES[c]);
    }
    return text;
  }

  for (var i = 0; i < str.length; i++) {
    if (to == "UTF-8") {
      text += UTF_8[str.charCodeAt(i)];
    } else if (to == "WINDOWS-1252") {
      text += WINDOWS_1252[str.charCodeAt(i)];
    } else if (to == "HTML_ENTITIES") {
      text += HTML_ENTITIES[str.charCodeAt(i)];
    }
  }

  return text;
};

export function generatekey(length) {
  var ret = "";
  while (ret.length < length) {
    ret += Math.random().toString(16).substring(2);
  }
  return ret.substring(0, length);
}

export function bigConsoleLog(logText, specialCharacter = "-") {
  console.log(
    `+${specialCharacter}${logText
      .split("")
      .map((letter) => specialCharacter)
      .join("")}${specialCharacter}+`,
  );
  console.log(`| ${logText} |`);
  console.log(
    `+${specialCharacter}${logText
      .split("")
      .map((letter) => specialCharacter)
      .join("")}${specialCharacter}+\n`,
  );
}

export function dataEnvio(dataResposta) {
  const dataISO = `${new Date(dataResposta).toISOString()}`.split("Z")[0];
  const dataISOTreated = `${
    `${new Date(dataISO).toISOString()}`.split("Z")[0]
  }+00:00`;
  const dataEnvio = `${new Date(dataISOTreated).toLocaleString()}`;

  return dataEnvio;
}

export function stripHTML(mensagem) {
  return mensagem.replace(/<.*?>/g, "").replace("&nbsp", "").trim();
}

export function putLinkButton(message) {
  const posAnchorDuvida = message.indexOf("<a") + 2;
  message = `${message.substring(0, posAnchorDuvida)}${
    posAnchorDuvida >= 2
      ? ` style="
            background-color: rgba(0,0,0, .8);
            height: 50px;
            padding-left: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            font-weight: 700;
            border-radius: 5px;
            padding-right: 10px;" `
      : ``
  }${message.substring(posAnchorDuvida)}`;

  return message;
}
export function textsGenerate(partner_url = "") {
  const texts = [
    undefined,
    {
      texto: `
            <t>
                Você deve estar se perguntando: Os treinamentos Lean Seis Sigma obedecem uma sequência? Qual a certificação mais adequada para o meu caso? Afinal, por onde devo começar?

                <br><br>
                <br><br>
                Que tal começar pelo curso que melhor traduz seus objetivos profissionais?
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/white-belt/${partner_url}'>White Belt:</a></strong> Você ainda não conhece o Lean Seis Sigma e deseja entender sua essência antes de se aprofundar? Comece por aqui! Ao se tornar um White Belt, você aprenderá os princípios básicos do Lean Seis Sigma e como aplicar o método DMAIC em um projeto de melhoria contínua.
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/yellow-belt/${partner_url}'>Yellow Belt:</a></strong> Se você deseja participar de projetos Lean Seis Sigma, tendo papel vital na operação dos mesmos, saiba que, ao se tornar um Yellow Belt, você estará apto a dar suporte aos Green Belts e Black Belts na implementação de projetos Lean Seis Sigma!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/green-belt/${partner_url}'>Green Belt:</a></strong> A partir desta faixa, uma competência muito importante se faz necessária: a liderança! Um Green Belt, é capaz de desenvolver projetos e liderar equipes de melhoria, além de ter um amplo conhecimento nas ferramentas mais utilizadas do Lean Seis Sigma. Vamos nessa?
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/black-belt/${partner_url}'>Black Belt:</a></strong> Imagine dedicar-se exclusivamente a liderar projetos de melhoria contínua em uma organização e ser um dos profissionais mais visados do mercado. Esse é o Black Belt! Seja capaz de resolver problemas corporativos de alta complexidade com a utilização de análises estatísticas mais avançadas!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/master-black-belt/${partner_url}'>Master Black Belt:</a></strong> Você já é Black Belt e quer liderar a transformação cultural de uma organização através da melhoria contínua? Ao se tornar Master Black Belt, você será um profissional respeitado por implementar diversos programas de melhoria dentro das empresas, treinando e motivando equipes de excelência.
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/projeto-pratico-aplicado-servicos/${partner_url}'>Projeto Prático Aplicado – Área de Serviços:</a></strong> Experiência prática de
                um projeto Seis Sigma no modelo EAD? Temos! No Projeto Prático
                Aplicado - Área de Serviços, você tem o desafio de melhorar o nível de
                serviço de atendimentos em uma empresa. Finalizando-o você alcança o
                tão sonhado certificado de Especialista Seis Sigma!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/projeto-pratico-aplicado-industria/${partner_url}'>Projeto Prático Aplicado – Área Industrial:</a></strong> Se você atua ou deseja
                atuar na área industrial, finalizou sua formação Seis Sigma e está em
                busca de experiência prática, você encontrou! No Projeto Prático
                Aplicado - Área Industrial, você tem o desafio de reduzir o número de
                falhas na entrega de tubos e escapamentos de uma indústria do aço.
            </t>
        `,
    },
    {
      texto: `
          <t>
            Nascido na Toyota, o Lean é uma metodologia japonesa que se expandiu pelo mundo e hoje é aplicado em empresas de todos os setores e portes, na busca pela redução de desperdícios, aumento da lucratividade e satisfação do cliente.
            <br><br>
            O profissional da Excelência Operacional é especialista na redução de custos e otimização de resultados, e deve estar preparado para aplicar o Lean em seu ambiente de trabalho, visando sempre fazer mais com menos! Seja esse profissional! Que tal começar pelo curso que melhor traduz seus objetivos?
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/introducao-lean-manufacturing/${partner_url}'>Introdução ao Lean Manufacturing:</a></strong> Já ouviu falar sobre a filosofia Lean e quer aprender mais? Ao longo deste treinamento você vai conhecer os 5 princípios Lean, os 8 desperdícios da produção e vai descobrir como implementar o método PDCA.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/fundamentos-lean/${partner_url}'>Formação em Fundamentos Lean:</a></strong> Tem interesse em trabalhar na eliminação de desperdícios e aumento de qualidade baseado na cultura Lean? Esse curso é para você! Com esta formação, você será capaz de entender a base da filosofia Lean, suas principais ferramentas, métricas e como fazer a gestão das mudanças!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/introducao-ao-wcm/${partner_url}'>Introdução ao World Class Manufacturing:</a></strong> Dê os primeiros passos na cultura de classe mundial! Com esse curso você vai aprender o que é e qual a origem do World Class Manufacturing, bem como as fundamentações e pilares técnicos da metodologia.
            <br><br>
            <strong><a href='https://www.voitto.com.br/digital/fundamentos-em-wcm/${partner_url}' target='_blank'>Fundamentos em WCM:</a></strong> Entenda de vez tudo o que está por trás da sigla WCM e aprofunde sua formação na cultura de classe mundial! Aprenda como garantir a excelência operacional e satisfação dos clientes através do funcionamento adequado dos sistemas de qualidade, manutenção e logística!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/lideres-kaizen/${partner_url}'>Formação de Líderes Kaizen:</a></strong> Quer estimular sua equipe a solucionar problemas com a técnica Kaizen? Com essa formação você será capaz de entender como o líder Kaizen utiliza a melhoria contínua para gerar grandes resultados e como fazer melhorias rápidas e assertivas baseadas na cultura Lean.
            <br><br>

            <strong><a target='_blank' href='https://www.voitto.com.br/digital/implantao-do-programa-5s/${partner_url}'>Implantação do Programa 5s:</a></strong> Quer aprender como organizar e deixar o seu ambiente de trabalho mais produtivo? Com esse curso, você aprenderá  todas as técnicas e métodos para planejar, implementar e manter um ambiente de alta produtividade com o programa 5S.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/manutencao-produtiva-total/${partner_url}'>Manutenção Produtiva Total:</a></strong> Esse curso é para você que deseja
            melhorar os resultados da sua empresa, eliminando perdas com
            equipamentos e pessoal! Ao final da formação, você será capaz de montar
            um plano para engajar toda a empresa na manutenção, reduzindo
            desperdícios e aumentando a produtividade!
            <br><br>

            <strong><a target='_blank' href='https://www.voitto.com.br/digital/aplicacoes-praticas-value-stream-mapping/${partner_url}'>Aplicações Práticas de Value Stream Mapping:</a></strong> Melhore os processos
            do seu negócio agora! Com este curso, você aprenderá como utilizar o
            Mapeamento da Cadeia de Valor (VSM) e estará apto a identificar as
            atividades que geram ou não valor para o seu cliente.

            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/wcm-pilar-seguranca/${partner_url}'>WCM: Pilar Segurança:</a></strong> Já conhece os fundamentos do WCM
            e tem
            interesse em saber como
            garantir a melhoria constante das condições de
            trabalho para os operadores? Com esse curso você
            vai
             entender como ter
            uma cultura de prevenção autônoma de segurança e saúde!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/wcm-pilar-cost-deployment/${partner_url}'>WCM: Pilar Cost Deployment:</a></strong> Aprofunde-se no Desdobramento de
            Custos! Com esse curso você terá a oportunidade de entender como o Cost
            Deployment atua, auxiliando na tomada de decisões, reduzindo os custos e
            aumentando a lucratividade!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/wcm-pilar-manutencao-autonoma/${partner_url}'>WCM: Pilar Manutenção Autônoma:</a></strong> Está em busca de entender como
            melhorar a disponibilidade dos meios de trabalho e a qualidade dos
            produtos?
            Esse curso é para você!
            Você será capaz de reduzir as perdas e
            quebras dos equipamentos, além de entender como melhorar a qualidade
            dos produtos!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/lean-logistics/${partner_url}'>Lean Logistics:</a></strong> Aprenda como reduzir custos no setor de Logística e
            Supply Chain! Nesse treinamento você entenderá como funciona o Lean no
            setor logístico e aprenderá como aplicar o mapeamento de fluxo de valor,
            passando pela armazenagem física e inovações na área.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/lean-office/${partner_url}'>Lean Office:</a></strong> Elimine os desperdícios no seu escritório! Nesta formação,
            vamos te mostrar como você pode transformar a área administrativa do seu
            negócio por meio da padronização de atividades, reorganização do layout,
            tornando-a mais produtiva e eficiente!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/lean-health-care/${partner_url}'>Lean Healthcare:</a></strong> Trabalha na área da saúde e deseja se aprofundar na
            metodologia Lean para liderar projetos de melhoria? Com essa formação
            você aprenderá como reduzir custos, filas e erros em hospitais, laboratórios
            e farmácias.
            Introdução ao Lean Construction:
            Conheça a metodologia Lean aplicada
            na Construção Civil! Nesse curso você vai aprender o que é e qual a origem
            do Lean e os princípios do Lean Construction.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/introducao-lean-construction/${partner_url}'>Introdução ao Lean Construction:</a></strong> Conheça a metodologia Lean aplicada
            na Construção Civil! Nesse curso você vai aprender o que é e qual a origem
            do Lean e os princípios do Lean Construction.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/lean-construction/${partner_url}'>Lean construction:</a></strong> Aplique a metolodogia Lean e elimine desperdícios na
            Construção Civil! Ao final desse curso você saberá como implementar a
            filosofia Lean na área de engenharia civil e analisar a eficiência do projeto
            por meio de métricas de controle!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/fundamentos-de-planejamento-e-controle-de-producao/${partner_url}'>Fundamentos de PCP:</a></strong> Quer iniciar a sua trajetória de aprendizado na
            gestão da produção de uma organização? Aprenda como distinguir as
            etapas de um PCP, classificar o sistema produtivo de uma organização e
            entender os fatores críticos que influenciam a administração da produção.
            <br><br>
          `,
    }, //2
    {
      texto: `
          <t>
            Cada vez mais os softwares de gestão são necessários para o profissional que deseja se destacar no mercado de trabalho. O domínio dos softwares mais usados pelas empresas pode representar uma virada de chave na sua carreira! Isso porque o mercado valoriza profissionais produtivos e que possuam habilidades técnicas avançadas para trabalhar com dados, ou seja, profissionais que fazem mais resultados em menos tempo!
            <br><br>
            Aqui, você encontra cursos que vão te ajudar a desenvolver estas habilidades! Se você não sabe por onde começar, podemos te ajudar! Escolha, nesta trilha de aprendizagem, os cursos que mais se encaixam às suas necessidades profissionais e se destaque!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/excel-introducao-2016/${partner_url}' target='_blank' >Introdução ao Excel:</a></strong> Começamos nossa trilha de aprendizagem com você que quer dar os primeiros passos em Excel. Aqui, você vai conhecer os fundamentos do software e aprender as principais fórmulas e recursos disponíveis, além de uma breve apresentação sobre como criar gráficos.
            <br><br>
            <strong><a href='https://www.voitto.com.br/digital/excel-basico-intermediario-2016/${partner_url}' target='_black'>Excel Básico ao Intermediário:</a></strong> Já conhece os fundamentos deste software, mas quer se aprofundar nas ferramentas e recursos disponíveis? Então esse curso foi feito para você! Manipular e organizar planilhas, utilizar funções básicas e essenciais e criar seus próprios gráficos serão tarefas simples!
            <br><br>
            <strong><a href='https://www.voitto.com.br/digital/excel-avancado-2016/${partner_url}' target='_blank'>Excel Avançando:</a></strong>  Se você é o tipo de pessoa que busca alcançar o topo do conhecimento desta ferramenta, então você está no lugar certo! Através de tabelas e gráficos dinâmicos, dashboards, funções financeiras e análise de dados, você vai se destacar nas apresentações!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/master-em-excel/${partner_url}' target='_blank' >Formação Master em Excel:</a></strong> Fazer um curso completo em Excel nunca foi tão fácil! Se você busca em um único curso ir do zero ao topo do conhecimento em Excel e dominar esta ferramenta, você está no lugar certo! Aqui você estará apto a criar planilhas avançadas, tabelas e gráficos dinâmicos, além de uma introdução a criação de macros.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/dashboard-de-gestao/${partner_url}' target='_blank' >Dashboard de Gestão:</a></strong> Se você deseja dominar a arte de criar dashboards gerenciais, este curso é pra você! Ao final desta formação você estará apto a montar gráficos e painéis dinâmicos incríveis para arrasar nas apresentações!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/vba-aplicado-a-negocios/${partner_url}' target='_blank' >VBA Aplicado a Negócios:</a></strong> Automatizar processos e rotinas no Excel tem se tornado um diferencial quando se trata de potencializar resultados. Se você busca por isso, este é o seu lugar! Você vai aprender a criar macros e desenvolver rotinas que facilitarão seu dia a dia e suas entregas.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/introducao-ao-power-bi/${partner_url}' target='_blank' >Introdução ao Power BI:</a></strong> Tem interesse em conhecer sobre esse software e aprender seus recursos básicos? Então você vai amar este curso! Compreenda a interface e as ferramentas básicas do Power BI, bem como o tratamento de dados e informações!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/power-bi/${partner_url}' target='_blank' >Power BI Aplicado a Negócios:</a></strong> Já pensou em transformar um grande volume de dados em insights para tomar decisões? Podemos te ajudar nisso! Aqui, você será capaz de criar relatórios e dashboards interativos com uma interface simples e atrativa.
            <br><br>
            <strong><a href='https://www.voitto.com.br/digital/fundamentos-essenciais-para-python/${partner_url}' target='_blank'>Fundamentos Essenciais para Python</a></strong>  Não sabe nada de programação, mas se interessa por análise de dados e deseja iniciar seu aprendizado sobre a linguagem Python? Então comece agora essa formação! Você vai aprender a desenvolver códigos básicos e essenciais, a lidar com a lógica de programação e a utilizar as principais ferramentas e estruturas desta linguagem.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/introducao-ao-minitab/${partner_url}' target='_blank' >Introdução ao Minitab 18:</a></strong> Conheça os conceitos básicos de estatística descritiva e os principais tipos de distribuição de probabilidade! Neste curso, você aprenderá os fundamentos do Minitab e suas ferramentas básicas.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/analises-no-minitab/${partner_url}' target='_blank' >Análises Estatísticas no Minitab 18:</a></strong> Se você deseja se aprofundar em análises estatísticas, principalmente associadas à metodologia Seis Sigma, você encontrou o curso certo! Aqui, você vai aprender a trabalhar com análises avançadas, que vão desde os gráficos básicos, cartas de controle e capabilidade à regressão linear, teste de hipóteses, ANOVA e muito mais.
            <br><br>
            <strong><a href='https://www.voitto.com.br/digital/autocad-2d/${partner_url}' target='_blank'>AutoCAD 2D:</a></strong>  Comece agora seu aprendizado na área de desenvolvimento de projetos! Com este curso, você estará apto a desenhar peças e desenvolver projetos de engenharia e arquitetura. Além disso, você será capaz de utilizar os principais recursos e ferramentas desse programa para se inserir e se destacar no mercado de trabalho!
            <br><br>
          </t>`,
    },
    {
      texto: `
          <t>
            Desenvolver habilidades que envolvam a gestão de um negócio pode ser a peça que faltava para aproximá-lo dos objetivos profissionais estabelecidos para sua carreira. Quer saber como? Seguindo a trilha de cursos que preparamos para você.
            <br><br>
            Aqui você encontra uma ampla variedade de cursos relacionados aconhecimentos técnicos fundamentais para quem tem interesse em se especializar como consultor em gestão. Vamos começar essa trajetória de capacitação?
            <br><br>
            Excelente! Escolha logo abaixo o curso que tem a sua cara, que estou te esperando lá! Até breve!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/fundamentos-essenciais-gestao-financeira/${partner_url}'>Fundamentos Essenciais da Gestão Financeira:</a></strong> Iniciamos essa trajetória com você que se interessa por finanças, seja para gerir um negócio ou aplicar os conceitos aprendidos na sua vida pessoal. Este curso vai te preparar para compreender a gestão financeira e seus desafios, utilizando indicadores a favor da empresa nos processos de tomada de decisão.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/gestao-financeira-analise-investimentos/${partner_url}'>Gestão Financeira e Análise de Investimentos:</a></strong> Deseja aprender os fundamentos e conceitos das finanças gerenciais e analisar investimentos? Nesse curso você estará apto para fazer planejamentos financeiro e orçamentário, gerir custos, fazer DRE, fluxo de caixa e muito mais.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/gestao-financeira-pessoal/${partner_url}'>Gestão Financeira Pessoal:</a></strong> Sempre teve dificuldades para gerir suas finanças pessoais? Com essa formação você vai aprender conceitos que vão transformar sua vida financeira e vão te ajudar a realizar seus sonhos com responsabilidade. Você será capaz de manter o controle dos gastos no dia-a-dia e aprender noções básicasde investimentos.
            <br><br>
            <strong><a href='https://www.voitto.com.br/digital/formacao-empreendedora/${partner_url}' target='_blank'>Formação Empreendedora:</a></strong> Se deseja transformar suas ideias em negócios de sucesso por um método disciplinado de preparação, técnicas de gestão e capacidade de execução? Então este é o curso certo para você! Seja capaz de maximizar suas chances de sucesso nesse meio tão dinâmico, além de facilitar a sua caminhada e potencializar seus resultados.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/home-office-de-alta-performance/${partner_url}'>Home Office de Alta Performance: </a></strong>  Está trabalhando home office e teve que se adaptar ao novo modo de trabalho? Aprenda habilidades valiosas para trabalhar remotamente e entregar resultados com excelência. Com este curso você será capaz de gerenciar melhor seu tempo e tarefas, melhorar a comunicação com sua equipe utilizando de ferramentas de forma assertiva e montar seu próprio workplace.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/planejamento-estrategico/${partner_url}'>Formulação de um Planejamento Estratégico:</a></strong> É empreendedor ou atua na área de gestão? Esta formação é para você! Com ela você será capaz de definir sua segmentação de mercado, fazer planejamentos estratégicos e de análises de riscos, e ainda obter resultados expressivos com esse aprendizado.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/gesto-para-resultados/${partner_url}'>Gestão Para Resultados:</a></strong>  Descubra neste curso como alcançar resultados significativos, liderando pessoas com foco nos objetivos e metas da organização por meio do PDCA! Com esta formação, você ainda será capaz de desenvolver e aplicar métodos gerenciais de forma eficiente e sustentável.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/estruturacao-sistema-gestao/${partner_url}'>Estruturação de um Sistema de Gestão para Resultados:</a></strong>  Está em busca em melhorar os sistemas de gestão de sua empresa? Então você está no lugar certo! Seja capaz de identificar melhorias, aplicar ferramentas de gestão e monitorar indicadores de mudança!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/estrategias-aumentar-receitas/${partner_url}'>Estratégias para Aumentar Receitas:</a></strong> Está em busca de ideias para aumentar seu faturamento? Esse curso vai te auxiliar a entender as principais estratégias de captação de clientes envolvendo técnicas infalíveis de marketing e vendas.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/recursos-humanos/${partner_url}'>Estruturação de Sistema de Recursos Humanos:</a></strong> Você é gestor, consultor ou profissional do setor de RH, e quer aprimorar seus conhecimentos sobre como lidar com contratações, turnover e engajamento dos colaboradores? Então esse curso foi feito pra você! Aprenda a estruturar um sistema de Recursos Humanos e otimize seus resultados!
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/fundamentos-essenciais-consultores/${partner_url}'>Fundamentos Essenciais para Consultores:</a></strong> É hora de dar os primeiros passos no ramo de consultoria! Com esse curso você saberá como elaborar uma proposta, precificar e ter clareza sobre seu nicho de mercado.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/formacao-consultor/${partner_url}'>Formação de um Consultor:</a></strong> Você atua ou sonha em trabalhar com consultoria? Se aprofunde neste tema aqui! Com este curso, você será capaz de entender como funciona esse mercado, como começar a oferecer serviços de consultoria e como elaborar projetos.
            <br><br>
            <strong><a target='_blank' href='https://www.voitto.com.br/digital/auditores-iso-9001/${partner_url}'>Formação de Auditores SGQ ISO 9001:</a></strong> Torne-se agora um auditor de Sistema de Gestão da Qualidade ISO 9001! Com esse curso você será capaz de se auditar, fazer relatórios de não-conformidades e apresentar resultados.
            <br><br>
          </t>`,
    }, //4
    {
      texto: `
            <t>
                Você sabe o que é VUCA? Os americanos usam essa expressão para explicaro mundo de hoje, onde tudo é volátil, incerto, complexo e ambíguo.
                <br><br>
                Em um cenário onde é difícil ter uma previsibilidade sobre o que nos espera no futuro, equipes e organizações precisam aprimorar algumas habilidades, dentre elas a capacidade de inovar e ser cada vez mais ágil. Como você está se preparando para essa nova realidade? Vamos começar essa trajetória de capacitação?
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/introducao-agile-scrum/${partner_url}' target='_blank' >Introdução ao Agile Scrum:</a></strong> Esse curso é o primeiro passo para quem quer aprender os princípios, conceitos, eventos, artefatos e tipos de certificações do Scrum. Com essa formação você entenderá como esse framework surgiu, seus princípios e os papéis de cada integrante!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/fundamentos-scrum-para-gestao-agil/${partner_url}' target='_blank' >Fundamentos Scrum para Gestão Ágil de Projetos:</a></strong> Deseja aprimorar os fundamentos essenciais do método Scrum? Esse curso é para você! Esteja preparado para gerenciar projetos Scrum e conquiste sua certificaçãode Scrum Foundation EXIN!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/formacao-scrum-master-exin/${partner_url}' target='_blank' >Formação de Scrum Master:</a></strong> Seja Master!! Com essa formação você será capaz de implementar o Scrum em uma organização, facilitando o processo de entregas ágeis, além de estar preparado para conquistar sua certificaçãode Scrum Master EXIN!
                <br><br>
                <strong><a href='https://www.voitto.com.br/digital/fundamentos-do-growth-hacking/${partner_url}' target='_blank'>Fundamentos do Growth Hacking:</a></strong>  Já ouviu falar em Growth Hacking e ficou curioso para aprender mais? Com esse curso você vai descobrir como encontrar oportunidades de crescimento para potencializar seus negócios e vai entender como implementar o modelo escalar na sua organização!
                <br><br>
                <strong><a href='https://www.voitto.com.br/digital/growth-hacking/${partner_url}' target='_blank'>Formação de Especialistas em Growth Hacking: </a></strong> Esse curso é para você que deseja se tornar um especialista em Growth Hacking! Aprenda como destacar o seu produto, aumentar sua base de clientes, calcular índices como o CAC e LTV e descubra a importância de conhecer seu mercado!
                <br><br>
            </t>
          `,
    },
    {
      texto: `
            <t>
                Exercer um cargo de liderança requer responsabilidades e habilidades específicas que podem ser desenvolvidas, aprimoradas e lapidadas com o tempo. Quer saber como? Seguindo nossa trilha de cursos!
                <br><br>
                Encontre abaixo o curso que tem a sua cara e nos vemos nele! Até breve!
                <br><br>
                <strong><a href='https://www.voitto.com.br/digital/lideranca-para-gestores/${partner_url}' target='_blank'>Liderança para Gestores:</a></strong> Começamos falando com você que deseja aprimorar suas habilidades como líder ou que está visando aquele tão sonhado cargo de liderança em seu trabalho. O Liderança para Gestores te prepara para gerenciar os principais desafios da liderança e para formar uma equipe de alto desempenho!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/lideranca-no-chao-de-fabrica/${partner_url}'>Liderança no Chão de Fábrica:</a></strong>  Você fazia parte de uma equipe operacional e foi promovido para liderá-la? Se você chegou nessa fase ou deseja alcançá-la, nosso curso vai te ensinar o caminho para ser reconhecido como um agente de mudança e transformação no gemba, onde tudo acontece!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/comunicacao-interpessoal-e-feedback/${partner_url}'>Comunicação Interpessoal e Feedback:</a></strong> Tem dificuldades para se comunicar com sua equipe e dar feedbacks assertivos? Com essa formação, você se sentirá mais preparado para resolver problemas causados por falta de alinhamento e falhas de comunicação em seu dia-a-dia.
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/oratoria-tecnicas-de-apresentacao/${partner_url}'>Oratória e Técnicas de Apresentação:</a></strong> Fazer aquela apresentação de resultados para diretoria, palestrar ou dar um treinamento para dezenas de pessoas é um grande desafio, mas você pode superá-lo! Essa formação vai te ensinar a se comunicar melhor em público e criar apresentações de alto impacto! Tudo isso com confiança e clareza!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/gestao-de-conflitos/${partner_url}'>Gestão de Conflitos:</a></strong> Para você que está procurando formas melhores de lidar com conflitos no ambiente de trabalho, te apresentamos o Gestão de Conflitos. Com esse curso, você não fugirá mais das conversas e situações difíceis, vencendo-as de forma cativante e conquistando a confiança da sua equipe.
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/sucesso-em-processo-seletivo/${partner_url}'>Como ter sucesso em um Processo Seletivo:</a></strong> Está em busca de recolocação no mercado de trabalho ou da sua primeira oportunidade? Comece aqui! Ao fim deste curso você vai se sentir mais confiante e preparado para todas as fases de um processo seletivo. Separe sua documentação e se prepare para a admissão!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/ingles-para-processos-seletivos/${partner_url}'>Inglês para Processos Seletivos:</a></strong> Do you speak English? Se você não possui confiança com seu inglês, nós te ajudamos a perder o medo de ser eliminado em um processo seletivo por isso! Se prepare para falar sobre você, seus estudos e sua experiência profissional de forma segura em inglês! And then, congratulations! You’re hired!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/gestao-do-tempo/${partner_url}'>Gestão do Tempo e Produtividade Profissional:</a></strong> A lista de tarefas está cheia e 24h no dia parecem não ser suficientes? Então te indicamos essa formação! Ao final do curso você  vai dominar técnicas e ferramentas para administrar melhor seu tempo e elencar suas reais prioridades.
                <br><br>
                <strong><a href='https://www.voitto.com.br/digital/estruturacao-de-trabalhos-academicos/${partner_url}' target='_blank'>Estruturação de trabalhos acadêmicos: </a></strong> Se sua monografia ou tese tem tirado seu sono, te ajudaremos a dormir mais tranquilo! Neste curso você entenderá o que é a Metodologia Científica, quais tópicos devem compor seu trabalho e como formatá-lo de acordo com as regras da ABNT. Vem diploma!
            </t>
          `,
    }, //6
    {
      texto: `
            <t>Estamos diariamente buscando novos modos de vender mais e melhor. Sabemos que ao fornecer um atendimento qualificado e atender verdadeiramente as necessidades do cliente, o resultado, muito provavelmente, será obter uma relação mais duradoura e proveitosa para ambas as partes.
                <br><br>
                Além disso, devido à crescente concorrência no mercado, as empresas precisam se aprofundar em estratégias e técnicas que as auxiliem na retenção de seus clientes e ajudem a conquistar novos. Aqui, você encontra cursos que vão te ajudar nesse quesito.
                <br><br>
                Se você não sabe por onde começar, nós podemos te ajudar com a nossa trilha de aprendizado. Vamos lá!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/tecnicas-de-negociacao/${partner_url}'>Técnicas de Negociação:</a></strong> Se você entende que negociar é uma arte e deseja dominar as boas práticas para fazer boas negociações, então você precisa conhecer este curso! Aqui, você vai aprender técnicas de negociação através de relações ganha-ganha e como identificar oportunidades de ganho mútuo.
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/tecnicas-de-vendas/${partner_url}'>Técnicas de Vendas e Excelência no Atendimento:</a></strong> Você é um gestor ou trabalha na área de vendas e acredita que um bom atendimento é um diferencial para o empreendimento? Seu lugar é aqui! Neste curso você vai aprender as melhores práticas e estratégias de mercado para fazer com que seu cliente se sinta realizado.
                <br><br>
                <strong><a href='https://www.voitto.com.br/digital/gatilhos-mentais-para-vendas/${partner_url}' target='_blank'>Gatilhos mentais para vendas: </a></strong> Se você quer destacar seu empreendimento no mercado, você precisa aprender sobre estratégias de vendas! Com este curso, você será capaz de entender os principais gatilhos e técnicas de persuasão que vão alavancar seu negócio através de estratégias de marketing, vendas e comunicação.
                <br><br>
            </t>
          `,
    },
    undefined,
    {
      texto: `
            <t>
                Se você quer de ser reconhecido pela sua capacidade de gerenciar projetos,   então   você   veio   ao   lugar   certo.   A   trilha   de   cursos Gerenciamento de Projetos fornece uma visão completa de comoaplicar as melhores práticas do mercado para obter bons resultados! Que tal começar sua formação agora? Vamos lá!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/introducao-ao-gerenciamento-de-projetos-na-pratica/${partner_url}'>Introdução ao Gerenciamento de Projetos:</a></strong> Você tem interesse em compreender os conceitos básicos em gestão de projetos? Então comece a sua formação por aqui! Com esse curso você vai aprender sobre o Project Management Institute (PMI) e como definir e gerenciar projetos.
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/gerenciamento-de-projetos-na-pratica/${partner_url}'>Gerenciamento de Projetos na Prática:</a></strong> Trabalha com gestão de projetos e busca otimizar os seus resultados? Com esse curso você terá a oportunidade de aprender os conhecimentos necessários para tirar do papel, executar e finalizar o seu projeto, maximizando o desempenho e os resultados da sua equipe!
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/introducao-ms-project-2016/${partner_url}'>Introdução ao Microsoft Project para Gerenciamento de Projetos:</a></strong> Conheça as funcionalidades do MS Project para gerenciar projetos! Com este curso você vai entender como funciona, suas aplicabilidades e como utilizar esse software na prática.
                <br><br>
                <strong><a target='_blank' href='https://www.voitto.com.br/digital/ms-project/${partner_url}'>Microsoft Project para Gerenciamento de Projetos:</a></strong> Encontre, neste curso, conteúdos avançados sobre o MS Project! Aprenda como alinhar conhecimentos metodológicos do PMBOK ao MS Project, potencializando o resultado dos seus projetos.
                <br><br>
                <strong><a href='https://www.voitto.com.br/digital/preparatorio-certificacao-pmp-pmbok-6/${partner_url}' target='_blank'>Preparatório para Certificação PMP</a></strong> Deseja conquistar a certificação Project Manager Professional (PMP) e precisa de orientação? Esse curso tem tudo que precisa! Saiba como é realizada a avaliação, o passo a passo do processo de certificação, quais são as comprovações e documentações necessárias, detalhes técnicos acerca da prova e as principais dicas para você alcançar êxito em seu exame. Boa sorte e sucesso na certificação!
            </t>
          `,
    }, //9
  ];

  return texts;
}

export const timeDiff = (deadend) => {
  const now = new Date();
  const limit = new Date(deadend);
  now.setHours(now.getHours() + (3 - now.getTimezoneOffset() / 60));
  limit.setHours(limit.getHours() + (3 - limit.getTimezoneOffset() / 60));

  const diff = Number(limit) - Number(now);

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const restdays = diff % (1000 * 60 * 60 * 24);
  const hours = Math.floor(restdays / (1000 * 60 * 60));
  const resthours = restdays % (1000 * 60 * 60);
  const minutes = Math.floor(resthours / (1000 * 60));
  const restminutes = resthours % (1000 * 60);
  const seconds = Math.floor(restminutes / 1000);

  return { days, hours, minutes, seconds };
};

export const compareTime = (deadend) => {
  const { days, hours, minutes, seconds } = timeDiff(deadend);
  return days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0;
};

export const tipoArtigos = [
  {
    value: 6,
    text: "KITS",
  },
  {
    value: 4,
    text: "VÍDEOS",
  },
  {
    value: 3,
    text: "FERRAMENTAS EM EXCEL",
  },
  {
    value: 2,
    text: "POSTS",
  },
  {
    value: 1,
    text: "EBOOKS",
  },
];

export const privilegios = () => {
  return [
    { value: "alunos*", label: "Alunos" },
    { value: "analytic", label: "Analytic" },
    { value: "banner", label: "Banner (cursos)" },
    { value: "blog/eu_colunista", label: "BLOG: Eu, colunista" },
    { value: "blog/pocketbook4you", label: "BLOG: PocketBook4You" },
    { value: "blog/adicionar_voittocast", label: "BLOG: Upload Voittocast" },
    { value: "blog/substituirPalavras", label: "BLOG: Substituir Palavras" },
    {
      value: "blog/palavraChaveCount",
      label: "BLOG: Contador de Plavras Chave",
    },
    { value: "blog/blog_destaques", label: "BLOG: Destaque da Home" },
    { value: "blog/edita_rodape", label: "BLOG: Editar Rodapé do artigo" },
    { value: "blog/criar", label: "BLOG: Escrever Publicação" },
    { value: "blog/listar", label: "BLOG: Listar Postagens" },
    { value: "blog/barra-lateral", label: "BLOG: Barra Lateral" },
    { value: "botoes", label: "BLOG: Botões de Ação" },
    { value: "segmentos", label: "BLOG: Segmentos" },
    { value: "blog/palavra_chave", label: "BLOG: Cadastro de Palavra Chave" },
    { value: "blog/materias_educativos", label: "BLOG: Materiais Educativos" },
    { value: "blog/imageposition", label: "BLOG: Posição da imagem do PDD" },
    { value: "blog/postscarousel", label: "BLOG: Posts do Carrossel" },
    { value: "blog/post-do-dia", label: "BLOG: Post do Dia" },
    { value: "blog/redirecionamentos", label: "BLOG: Redirecionamentos" },
    { value: "blog/colunistas", label: "BLOG: Colunistas" },
    { value: "blog/voittocast", label: "BLOG: Voittocast" },
    { value: "blog/editar_home", label: "BLOG: Editar Home" },
    {
      value: "blog/adiciona_area_categoria",
      label: "BLOG: Adicionar subcategoria à categoria",
    },
    { value: "blog/edita_subcategoria", label: "BLOG: Editar subcategorias" },
    {
      value: "blog/edita_materiais_subcategoria",
      label: "BLOG: Editar materiais dos segmentos",
    },
    { value: "blog/pocketbook4you", label: "POCKETBOOK4YOU: Criar" },
    { value: "blog/listar_pocketbook4you", label: "POCKETBOOK4YOU: Editar" },
    {
      value: "blog/listar_pocketbook4you_freelas",
      label: "POCKETBOOK4YOU: Validar",
    },
    {
      value: "blog/listar_trilha_corrida",
      label: "POCKETBOOK4YOU: Trilha Corrida",
    },
    {
      value: "blog/pocketbook_do_dia",
      label: "POCKETBOOK4YOU: Pocketbook do dia",
    },
    {
      value: "blog/listar_trilha_pocketbooks",
      label: "POCKETBOOK4YOU: Lista de Trilhas &#128526;",
    },
    { value: "cidades", label: "Cidades" },
    { value: "consultores/criar", label: "Cadastrar Consultor" },
    { value: "consultores", label: "Lista de Consultores" },
    { value: "controle_envios", label: "Controle de Envios" },
    {
      value: "controle_indicacoes/specials_vouchers",
      label: "Busca de parceiros",
    },
    { value: "login-react-js", label: "Login React JS" },

    { value: "controle_indicacoes", label: "Busca de indicações" },
    { value: "controle_pedido", label: "Controle de Pedidos" },
    { value: "bandeiras_cart", label: "Controle de taxas (bandeiras)" },
    { value: "cupons/promoVingente", label: "Promoções Vingentes" },
    {
      value: "cursos/redirecionamento_treinamento",
      label: "CURSOS: Redirecionamento de Treinamento",
    },
    { value: "cursos/criar", label: "CURSOS: Lançar Curso" },
    { value: "cursos/ativos", label: "CURSOS: Cursos Ativos" },
    { value: "cursos/inativos", label: "CURSOS: Cursos Inativos" },
    { value: "cursos/conteudo", label: "CURSOS: Conteúdo das Páginas" },
    { value: "banner/faq", label: "Mudanças FAQ" },
    { value: "depoimentos", label: "Depoimentos" },
    { value: "alunos/voittocoins", label: "ALUNOS: Inserir Voitto Coins" },
    { value: "alunos/atribuir", label: "ALUNOS: Atribuir Curso à Aluno" },
    { value: "ead/barra", label: "EAD: Barra Lateral Dashboard Aluno" },
    { value: "ead/certificados", label: "EAD: Criador de Certificados" },
    { value: "ead/combos", label: "EAD: Combos Plataforma" },
    { value: "ead/cursos", label: "EAD: Cursos Plataforma" },
    { value: "ead/duvidas", label: "EAD: Controle de dúvidas" },
    { value: "ead/pedidosExtensao", label: "EAD: Pedidos de extensão" },
    { value: "emails", label: "E-mails" },
    { value: "empresas", label: "Empresas" },
    { value: "entregas-correios", label: "Entregas Correios" },
    { value: "inscricoes/ativos", label: "Inscrições Ativos" },
    { value: "inscricoes/inativos", label: "Inscrições Inativos" },
    { value: "menu", label: "Editar Menu" },
    { value: "HistoriasDeSucesso", label: "Historias de sucesso" },
    { value: "notifications/criar", label: "Notificações" },
    { value: "pagamentos", label: "Pagamentos" },
    { value: "pagina-vendas-especial", label: "Página de Vendas Especial" },
    { value: "pesquisas", label: " Pesquisas de Satisfação" },
    { value: "presenciais/treinamentos", label: "Treinamentos" },
    { value: "relatorios", label: "Relatórios" },
    { value: "relatorioGeral/:empresa", label: "Relatório Geral" },
    { value: "pagamento-especial/:plano", label: "Pagamento Especial" },
    { value: "campaign", label: "Campanhas de Administração" },
    { value: "campaign/criar", label: "Criação de Campanhas de Administração" },
    { value: "academy", label: "Administração de Cursos da Academy" },
    { value: "eventos/criar", label: "Criar eventos" },
    { value: "pocketbook", label: " Pocketbook" },
    { value: "transferir_conta", label: "Transferir Conta" },
    { value: "gerador_certificados", label: "Gerador Cert. Seis Sigma Criar" },
    {
      value: "gerador_certificados/listar",
      label: "Gerador Cert. Seis Sigma Listar criados",
    },
    { value: "app/live", label: "APP: Anuncio ao vivo" },
    { value: "app/notificacao", label: "APP: Notificação Geral" },
    {
      value: "app/notificacao_pessoa",
      label: "APP: Notificação Pessoa Especifica",
    },
    { value: "historiasdesucesso", label: "Histórias de Sucesso" },
    { value: "logs", label: "Logs" },
    { value: "estatisticas", label: "Estatísticas" },
  ];
};

export const comboVerify = async (idCurso) => {
  const listAllCombos = await producaov2.get("/combos");
  return listAllCombos.data.includes(idCurso);
};

export const verifyCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, "");
  if (cpf == "") return false;
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length != 11 ||
    cpf == "00000000000" ||
    cpf == "11111111111" ||
    cpf == "22222222222" ||
    cpf == "33333333333" ||
    cpf == "44444444444" ||
    cpf == "55555555555" ||
    cpf == "66666666666" ||
    cpf == "77777777777" ||
    cpf == "88888888888" ||
    cpf == "99999999999"
  )
    return false;
  // Valida 1o digito

  const op = {
    add: 0,
    rev: 0,
  };

  op.add = 0;
  for (let i = 0; i < 9; i++) op.add += parseInt(cpf.charAt(i)) * (10 - i);
  op.rev = 11 - (op.add % 11);
  if (op.rev == 10 || op.rev == 11) op.rev = 0;
  if (op.rev != parseInt(cpf.charAt(9))) return false;
  // Valida 2o digito
  op.add = 0;
  for (let i = 0; i < 10; i++) op.add += parseInt(cpf.charAt(i)) * (11 - i);
  op.rev = 11 - (op.add % 11);
  if (op.rev == 10 || op.rev == 11) op.rev = 0;
  if (op.rev != parseInt(cpf.charAt(10))) return false;
  return true;
};

export const cmToPx = (cm) => {
  return cm * 37.795275591;
};

export const pxToCm = (px) => {
  return px / 37.795275591;
};

//função usada para formatar texto que vem do banco ao se usar o Draft antigo para o novo
export const stripslashes = (text) => {
  let newText = text;
  newText = newText.replace(/\\\x00/g, "\x00");
  newText = newText.replace(/\\\n/g, "\n");
  newText = newText.replace(/\\\r/g, "\r");
  newText = newText.replace(/\\\x1a/g, "\x1a");
  newText = newText.replace(/\\"/g, '"');
  newText = newText.replace(/\\\\/g, "\\");

  return newText;
};

export const cleanCookies = async () => {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
};

export const LinkFuturoUsers = [
  "guilherme.pereira@voitto.com.br",
  "arthur.filippino@voitto.com.br",
  "bianca.oliveira@voitto.com.br",
  "larissa.barbieri@voitto.com.br",
];

export const menuAdmin = [
  {
    label: "Gestão de Alunos",
    icon: "user",
    subLinks: [
      {
        label: "Listar alunos",
        link: "/admin/alunos",
      },
      // {
      //   label: "Relatório - Inscrições (revisar)",
      //   link: "/admin/inscricoes",
      // },
      // {
      //   label: "Criar Aluno (dev)",
      //   link: "/",
      // },
      // {
      //   label: "Painel de Operações",
      //   link: "/admin/operacoes",
      // },
      // {
      //   label: "Controle de Projetos",
      //   link: "/admin/controle-de-projetos",
      // },
      // {
      //   label: "Projetos - Feedback (juntar)",
      //   link: "/admin/feedback-controle",
      // },
      // {
      //   label: "Controle de Envios",
      //   link: "/admin/controle_envios",
      // },
      {
        label: "Atribuir Curso a Aluno",
        link: "/admin/alunos/atribuir",
      },
      {
        label: "Atribuir Trilha a Aluno",
        link: "/admin/trilhas/listar",
      },
      // {
      //   label: "Editar MBA do Aluno",
      //   link: "/admin/mba/list/usuario",
      // },
      {
        label: "Atribuir Certificado a Aluno",
        link: "/admin/certificados/novo",
      },
      {
        label: "Certificados In-Company",
        link: "/admin/certificados/turmas",
      },
      //Migrar funcionalidade para o listar aluno detalhe
      {
        label: "Editar Tempo de Acesso",
        link: "/admin/alunos/validade-curso",
      },
      {
        label: "Migrar conta de Aluno",
        link: "/admin/transferir_conta",
      },
      //Migrar funcionalidade para o listar aluno detalhe
      {
        label: "Mapeamento de Competencias",
        link: "/admin/alunos/mapeamento-de-competencias",
      },
      // {
      //   label: "Atribuir MBA a Aluno (Integrar)",
      //   link: "/admin/mba/atribuir",
      // },
      // {
      //   label: "Remover MBA de Aluno (Integrar)",
      //   link: "/admin/mba/remover",
      // },
      {
        label: "Controle de Documentos",
        link: "/admin/mba/documentos",
      },
      {
        label: "Logs do Sistema",
        link: "/admin/logs-do-sistema",
      },
      // {
      //   label: "Bloquear Acesso de Aluno",
      //   icon: "ban",
      //   link: "/admin/bloqueio-acesso",
      // },
      // {
      //   label: "Inserir Voittocoins",
      //   link: "/admin/alunos/voittocoins",
      // },
    ],
  },
  {
    label: "Gestão de Produtos",
    icon: "cubes",
    subLinks: [
      // {
      //   label: "Dashboard - (ampliar)",
      //   link: "/admin/dashboard/mba",
      // },
      // {
      //   label: "Relatorio de Produtos (dev)",
      //   link: "/",
      // },
      {
        label: "Gestão de Cursos",
        link: "/admin/cursos/conteudo",
      },
      {
        label: "Gestão de Formação/MBA",
        link: "/admin/ead/combos",
      },
      {
        label: "Criar Teste de Conhecimento",
        link: "/admin/ead/testes",
      },
      {
        label: "MBA Molde | Ao Vivo",
        link: "/admin/mba/list",
      },
      // {
      //   label: "Criar Ciclo de Mentorias e Aulas abertas (Webséries)",
      //   link: "/admin/webserie-playlist/criar",
      // },
      {
        label: "Gestão de Consultores",
        link: "/admin/consultores",
      },
      {
        label: "Gestão de Lives ",
        link: "/admin/webserie-playlist",
      },
      {
        label: "Aplicativos - Avaliações",
        link: "/admin/voittoapp/ratings",
      },
      {
        label: "Resumos de Aula",
        link: "/admin/resumos-de-aula",
      },
    ],
  },
  {
    label: "Gestão Financeira",
    icon: "money",
    subLinks: [
      {
        label: "Gerar Link de Pagamento",
        link: "/admin/pagamentos",
      },
      {
        label: "Gerar Link de Extensão",
        link: "/admin/extensao",
      },
      {
        label: "Gerar Link Futuro",
        link: "/admin/planos/link-futuro",
        requiredEmails: LinkFuturoUsers,
      },
      {
        label: "Gerar Boletos",
        link: "/admin/pagamentos/boleto",
      },
      // {
      //   label: "Gestão de Planos Pagarme",
      //   link: "/admin/planos/link",
      // },
      {
        label: "Gestão de Assinaturas",
        link: "/admin/pagarme/assinantes",
      },
      {
        label: "Gestão de Faturas",
        link: "/admin/faturasV2",
      },
    ],
  },
  {
    label: "Gestão de Operações",
    icon: "sitemap",
    subLinks: [
      {
        label: "Painel de Operações",
        link: "/admin/operacoes",
      },
      {
        label: "Controle - Mapeamento de Competências",
        link: "/admin/mapeamento-de-competencias",
      },
      {
        label: "Controle de FAQ",
        link: "/admin/faq",
      },
      {
        label: "Criar Certificado",
        link: "/admin/certificados/novo",
      },
      {
        label: "Criar nova Notificação",
        link: "/admin/notificacoes/push",
      },
      {
        label: "Listar Certificados",
        link: "/admin/certificados",
      },
      {
        label: "Listar Testes de Conhecimento",
        link: "/admin/testes/resultados",
      },
      {
        label: "Listar Pesquisas (Site)",
        link: "/admin/pesquisa",
      },
      {
        label: "Upload de Anexos",
        link: "/admin/upload/anexos",
      },
    ],
  },
  {
    label: "Marketing | Parcerias",
    icon: "bullhorn",
    subLinks: [
      // {
      //   label: "Relatório: Pacotes Vendidos",
      //   link: "/admin/relatorios/pacotes-vendidos",
      // },
      // {
      //   label: "Criar Página de Captura (Futuro)",
      //   link: "/",
      // },

      // {
      //   label: "Criar Página de Venda (Futuro)",
      //   link: "/",
      // },

      // {
      //   label: "Criar Popup (Futuro)",
      //   link: "/",
      // },
      {
        label: "Campanha",
        link: "/admin/marketing/campanhas",
      },
      {
        label: "Listar Cupons",
        link: "/admin/cupons",
      },
      {
        label: "Criar Cupom",
        link: "/admin/cupons/criar",
      },
      {
        label: "Analytics - Dados de Aluno Por Curso",
        link: "/admin/analytic/dados-aluno-por-cursos",
      },
      {
        label: "Editar Carrosseis de Vendas",
        icon: "columns",
        link: "/admin/painel_carrosseis",
      },
      {
        label: "Indicações",
        link: "/admin/eventos/indicacoes",
      },
    ],
  },
  {
    label: "Relatórios",
    icon: "chart line",
    subLinks: [
      {
        label: "Inscrições",
        link: "/admin/relatorios/inscricoes",
      },
      // {
      //   label: "Inscrições - Pagas",
      //   link: "/admin/relatorios/inscricoes/minificado",
      // },
      {
        label: "Recorrencia Pagarme",
        link: "/admin/relatorios/pagamentos-futuros",
      },
      {
        label: "Cobranças Pagarme",
        link: "/admin/relatorios/pagamentos-periodo",
      },
      {
        label: "Inadimplentes",
        link: "/admin/relatorios/inadimplentes",
      },
      {
        label: "Inadimplentes Boleto",
        link: "/admin/relatorios/inadimplentes/boleto",
      },
      {
        label: "Relatórios Para Empresas",
        link: "/admin/empresas/relatorios",
      },
      {
        label: "Compra de Materiais",
        link: "/admin/relatorios/subitens",
      },
      {
        label: "Matricula MBA",
        link: "/admin/relatorios/mba",
      },
      {
        label: "Progressos MBA",
        link: "/admin/relatorios/progresso/mba",
      },
      {
        label: "Próximos do Vencimento",
        link: "/admin/relatorios/close-to-expiring",
      },
      {
        label: "Pesquisas de Satisfação",
        link: "/admin/relatorios/pesquisa",
      },
      // {
      //   label: "Pesquisas de Satisfação MBA",
      //   link: "/admin/relatorios/pesquisa-mba",
      // },
      {
        label: "Relatorios tickets",
        link: "/admin/relatorios/tickets",
      },
      {
        label: "Pedidos por período",
        link: "/admin/relatorios/pedidos-periodo",
      },
      {
        label: "Pedidos de produto por período",
        link: "/admin/relatorios/pedidos-produto-periodo",
      },
      {
        label: "Pesquisa Forms (Site)",
        link: "/admin/relatorios/survey",
      },
      {
        label: "Primeiro Contato",
        link: "/admin/relatorios/primeiro-contato",
      },
      {
        label: "Alunos MBA",
        link: "/admin/relatorios/alunos-mba",
      },
    ],
  },
  {
    label: "Para Empresas",
    icon: "building",
    subLinks: [
      {
        label: "Listar LMS's",
        link: "/admin/lms",
      },
      // {
      //   label: "Criar Empresas",
      //   link: "/admin/novo-empresas/criar",
      // },
      // {
      //   label: "Relatórios Específicos",
      //   link: "/admin/empresas/relatorios",
      // },
      {
        label: "Listar Painel Coorporativo",
        link: "/admin/empresas",
      },
      // {
      //   label: "Antigo Criar",
      //   link: "/admin/empresas/criar",
      // },
      // {
      //   label: "Antigo Solicitacoes",
      //   link: "/admin/empresas/solicitacoesEmpresas",
      // },
    ],
  },
  {
    label: "Recursos Humanos",
    icon: "briefcase",
    subLinks: [
      {
        label: "Criar Vaga",
        link: "/admin/rh/vacancies/create",
      },
      {
        label: "Lista de Vagas",
        link: "/admin/rh/vacancies",
      },
      {
        label: "Banco de Talentos",
        link: "/admin/rh/bank-of-talents",
      },
    ],
  },
  {
    label: "PocketBook4You",
    icon: "book",
    subLinks: [
      {
        label: "Usuários",
        link: "/admin/blog/pocketbook4you/usuarios",
      },
      {
        label: "Cupons",
        link: "/admin/pocketbook/cupons",
      },
      {
        label: "Indique e Ganhe",
        link: "/admin/pocketbook/indique-e-ganhe",
      },
      {
        label: "Histórico de Usuário com Planos",
        link: "/admin/pocketbook/planos",
      },
      {
        label: "Listar Contas Excluídas",
        link: "/admin/pocketbook/contas-excluidas",
      },
      {
        label: "Livros recomendados",
        link: "/admin/pocketbook/livros-recomendados",
      },
      {
        label: "Livros Avaliados",
        link: "/admin/pocketbook/avaliacoes",
      },
      {
        label: "Trial",
        link: "/admin/pocketbook/trial",
      },
      {
        label: "Cadastrar Parceiro",
        link: "/admin/blog/pocketbook4you/parceiros/cadastro",
      },
      {
        label: "Listar Solicitacoes de parceria",
        link:
          "/admin/blog/pocketbook4you/parceiros/Listagemsolicitacoesparceiros",
      },
    ],
  },
  {
    label: "Legado",
    icon: "user",
    subLinks: [
      {
        label: "Listar Cursos Ativos",
        link: "/admin/cursos/ativos",
      },
      {
        label: "Listar Cursos Inativos (Juntar com ativos)",
        link: "/admin/cursos/inativos",
      },
      {
        label: "Gestão de Parceiros",
        link: "/admin/parceiros",
      },
      {
        label: "Cadastrar Histórias de Sucesso",
        icon: "star",
        link: "/admin/historiasdesucesso",
      },
      {
        label: "Eventos - Listar",
        link: "/admin/eventos",
      },
      {
        label: "Eventos - Criar Evento",
        link: "/admin/eventos/criar",
      },
      {
        label: "Eventos - Emails Eventos",
        link: "/admin/eventos/email",
      },
      {
        label: "Eventos - Listar Indicações",
        link: "/admin/eventos/indicacoes",
      },
      {
        label: "Eventos - Cadastrar em Evento",
        link: "/admin/eventos/indicacoes",
      },
      {
        label: "Eventos - Enviar emails",
        link: "/admin/inscricoes-eventos/enviar-emails",
      },
      {
        label: "Analytics - Dados Absolutos",
        link: "/admin/analytic/dados-absolutos",
      },
      {
        label: "Analytics - Cursos",
        link: "/admin/analytic/cursos",
      },
      {
        label: "Analytics - Pessoa Curso Status",
        link: "/admin/analytic/pessoas_cursos_status",
      },
      {
        link: "/admin/app/live",
        label: "Aplicativos Voitto - Anuncio ao vivo",
      },

      {
        link: "/admin/app/notificacao",
        label: "Aplicativos Voitto - Notificação Geral",
      },

      {
        link: "/admin/app/notificacao_pessoa",
        label: "Aplicativos Voitto - Notificação Pessoa Especifica",
      },
      {
        label: "Presenciais - Treinamentos",
        link: "/admin/presenciais/treinamentos",
      },
      {
        label: "Pocketbook4you - Listar Artigos",
        link: "/admin/blog/pocketbook4you",
      },
      {
        label: "Pocketbook4you - Criar",
        link: "/admin/blog/pocketbook4you/criar",
      },
      {
        label: "Pocketbook4you - Trilha Corrida",
        link: "/admin/blog/pocketbook4you/trilhas",
      },
      {
        label: "Pocketbook4you - Pocketbook do dia",
        link: "/admin/blog/pocketbook4you/pocketDia",
      },
      {
        label: "Webserie - Listar Episódios",
        link: "/admin/webserie-episodio",
      },
      {
        label: "Webserie - Criar Episódio",
        link: "/admin/webserie-episodio/criar",
      },
      {
        label: "Webserie - Listar Colaboradores",
        link: "/admin/webserie-colaborador",
      },
      {
        label: "Webserie - Criar Colaboradores",
        link: "/admin/webserie-colaborador/criar",
      },
      {
        label: "Personalite",
        link: "/admin/personalite/gerenciar_cursos",
      },
      {
        label: "Emails",
        link: "/admin/emails",
      },
      {
        label: "Pedidos de extensão",
        link: "/admin/pedidosExtensao",
      },
      {
        label: "Indicações - Busca de Parceiros",
        link: "/admin/controle_indicacoes/specials_vouchers",
      },
      {
        label: "Indicações - Busca",
        link: "/admin/controle_indicacoes",
      },
      {
        label: "Controle de Depoimentos",
        icon: "comments",
        link: "/admin/depoimentos",
      },
      {
        label: "Simulados - Listar",
        link: "/admin/simulados",
      },
      {
        label: "Simulados - Criar",
        link: "/admin/simulados/criar",
      },
      {
        label: "Simulados - Questões",
        link: "/admin/questoes",
      },
      {
        label: "Simulados - Atribuir",
        link: "/admin/atribuir_simulados",
      },
      {
        label: "Academy - Listar Cursos",
        link: "/admin/academy/cursos",
      },
      {
        label: "Academy - Listar Mudanças Pendentes",
        link: "/admin/academy/histories",
      },
      {
        label: "Ame Conciliação",
        icon: "cash",
        link: "/admin/ame-conciliacao",
      },
      {
        label: "Certificados de Múltiplas Assinaturas",
        link: "/admin/ead/certificados/cursos",
      },
      {
        label: "Gerenciamento de Lives",
        link: "/admin/webseries",
      },
      {
        label: "Criar Webpush Notification",
        link: "/admin/disparaNotificacao",
      },
      {
        label: "Criar notificação por curso em andamento",
        link: "/admin/notificacoes/cursoEmAndamento",
      },
      {
        label: "Alunos All in anual",
        icon: "user",
        link: "/admin/alunos/new-allin",
      },
      {
        label: "Cursos - Mudanças FAQ",
        link: "/admin/banner/faq",
      },
      {
        label: "Logs Voittocoins",
        link: "/admin/logsVoittoCoin",
      },
      {
        label: "Pedidos - Ame",
        link: "/admin/ame-pedidos",
      },
      {
        label: "Pedidos - Pix",
        link: "/admin/pix-pedidos",
      },
    ],
  },
];

export const generateJSID = () => {
  const numbers =
    Math.round(new Date().getTime() / 1000) +
    Math.round(new Date().getTime() / 1000) +
    Math.round(new Date().getTime() / 1000) +
    Math.round(new Date().getTime() / 1000);

  return Buffer.from(numbers.toString())
    .toString("base64")
    .replace(new RegExp("=", "g"), "");
};
export const datePattern = (dateSend) => {
  const date = new Date(dateSend);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
};

export const generateCupomCode = (base) => {
  const baseCode = uuidv4().replace(/-/g, "").slice(0, 12).toUpperCase();

  if (!base) {
    return baseCode;
  }

  const pattern = new RegExp("{{baseCode}}", "g");

  return base + baseCode;
};

export const returnValidate = (status) => {
  switch (status) {
    case "0":
      return "+1 mounth";
    case "1":
      return "+2 mounths";
    case "2":
      return "+3 mounths";
    case "3":
      return "+4 mounths";
    case "4":
      return "+5 mounths";
    case "5":
      return "+6 mounths";
    case "6":
      return "+7 mounths";
    case "7":
      return "+8 mounths";
    case "8":
      return "+9 mounths";
    case "9":
      return "+10 mounths";
    case "10":
      return "+11 mounths";
    case "11":
      return "+12 mounths";
    default:
      return "+6 mounths";
  }
};

export const formatValue = (value) => {
  if (!value) return "";
  const str = value.toString();
  return str.slice(0, -2) + "," + str.slice(-2);
};

export const getISODateWithoutTimezone = (possibleDate) => {
  if (!possibleDate) {
    return possibleDate;
  }

  const date = new Date(possibleDate);

  if (date.toString() === "Invalid Date") {
    return possibleDate;
  }

  const hourWihoutTimezone = date.getHours() - date.getTimezoneOffset() / 60;
  date.setHours(hourWihoutTimezone);

  return date.toISOString();
};

export const canEditOrDelete = (email, path) => {
  // verificar se o usuário atual está na lista de usuários permitidos
  const isGodPrivUser = godPrivUsers.users.some(
    (godPrivUser) => godPrivUser === email,
  );
  const isParceriaUser = parceriaUsers.users.some(
    (parceriaUser) =>
      parceriaUser === email && parceriaUsers.routes.includes(path),
  );
  const isMktUsers = mktUsers.users.some(
    (mktUsers) => mktUsers === email && mktUsers.routes.includes(path),
  );
  const isComercialUsers = comercialUsers.users.some(
    (comercialUsers) =>
      comercialUsers === email && comercialUsers.routes.includes(path),
  );
  // const isProdutoUsers =  produtoUsers.users.some((produtoUsers) => (
  //   produtoUsers === email &&
  //   (produtoUsers.routes.includes(path))
  // ));
  const isBlogUsers = blogUsers.users.some(
    (blogUsers) => blogUsers === email && blogUsers.routes.includes(path),
  );
  const isCsOpUser = csOpUsers.users.some(
    (csOpUser) =>
      csOpUser === email &&
      (csOpUsers.routes.includes(path) || csOpUsers.routes.includes("all")),
  );
  const isConsultorUser = consultorUsers.users.some(
    consultorUsers(
      consultorUsers === email && consultorUsers.routes.includes(path),
    ),
  );
  return (
    isGodPrivUser ||
    isParceriaUser ||
    isCsOpUser ||
    isMktUsers ||
    isComercialUsers ||
    isBlogUsers ||
    isConsultorUser
  );
};

export const TIUsers = [
  "ti@voitto.com.br",
  "guilherme.pereira@voitto.com.br",
];

export const financialUsers = [
  "bianca.oliveira@voitto.com.br",
  "financeiro@voitto.com.br",
];

export const godPrivUsers = {
  users: [
    ...TIUsers,
    ...financialUsers,
    "thiago.oliveira@voitto.com.br",
    "larissa.barbieri@voitto.com.br",
    "ped@voitto.com.br",
    "raquel.auday@voitto.com.br",
    "coordenacaoacademica@voitto.com.br",
    "vinicius.araujo@voitto.com.br",
    "renata.gazola@voitto.com.br",
    "julio.gravina@voitto.com.br",
    "adriano.nascimento@voitto.com.br",
    "marcony.xavier@voitto.com.br",
    "luan.moreira@voitto.com.br",
    "tulio.pacheco@voitto.com.br",
    "igor.andre@voitto.com.br",
    "arthur.filippino@voitto.com.br",
    "maria.queiroz@voitto.com.br",
    "leticia.correa@voitto.com.br",
    "joao.barbosa@voitto.com.br",
    "gabriel.passos@voitto.com.br",
    "rafaela.nogueira@voitto.com.br",
    "tarcisio.souza@voitto.com.br",
    "mylena.zanganelli@voitto.com.br",
  ],
  routes: ["all"],
};
//god

export const csOpUsers = {
  users: ["abel.oliveira@voitto.com.br"],
  routes: ["all"],
};
//CS
export const mktUsers = {
  users: [""],
  routes: [
    "/admin",
    "/admin/pocketbook/cupons",
    "/admin/pocketbook/cupons/criar",
    "/admin/pocketbook/cupons/detalhes/:id",
    "admin/faixas",
    "/admin/relatorios",
    "/admin/relatorios/inscricoes",
    "/admin/relatorios/inscricoes/minificado",
    "/admin/relatorios/utm",
    "/admin/relatorios/espera",
    "/admin/relatorios/subitens",
    "/admin/relatorios/pacotes-vendidos",
    "/admin/relatorios/espera",
    "/admin/faixas",
    "/admin/faixas/editar/",
    "/admin/analytic/pessoas_cursos_status",
    "/admin/faixas/criar/",
    "/admin/eventos",
    "/admin/cupons",
    "/admin/cupons/criar",
    "/admin/cupons/:id",
    "/admin/cupons/relatorio",
  ],
};
//Mk

// export const  produtoUsers = {
//   users: [
//     "ti@voitto.com.br"
//     ],
//     routes: ["/admin ", "/admin/cursos/ativo","/admin/pocketbook/cupons","/admin/pocketbook/cupons/criar","/admin/pocketbook/cupons/detalhes/:id","/admin/relatorios","/admin/relatorios/inscricoes","/admin/relatorios/inscricoes/minificado","/admin/relatorios/utm","/admin/relatorios/espera","/admin/relatorios/subitens", "/admin/relatorios/pacotes-vendidos"]
// };
//pu

export const parceriaUsers = {
  users: [""],
  routes: [
    "/admin",
    "/admin/alunos",
    "/admin/pocketbook/cupons",
    "/admin/pocketbook/cupons/criar",
    "/admin/pocketbook/cupons/detalhes/:id",
    "/admin/relatorios/tickets",
    "/admin/relatorios/pacotes-vendidos",
    "/admin/relatorios/utm",
    "/admin/relatorios/inscricoes/minificado",
    "/admin/relatorios/espera",
    "/admin/relatorios/pesquisa",
    "/admin/relatorios/inscricoes",
    "/admin/relatorios",
    "/admin/controle_indicacoes",
    "/admin/controle_indicacoes/specials_vouchers",
    "/admin/historiasdesucesso/detalhes/:id",
    "/admin/historiasdesucesso/criar",
    "/admin/historiasdesucesso",
    "/admin/analytic/dados-aluno-por-cursos",
    "/admin/analytic/dados-absolutos",
    "/admin/analytic/pessoas_cursos_status",
    "/admin/analytic/cursos",
    "/admin/emails/detalhes/:id",
    "/admin/emails/criar",
    "/admin/emails",
    "/admin/cupons/:id",
    "/admin/cupons/criar",
    "/admin/cupons/relatorio",
    "/admin/cupons",
    "/admin/parceiros",
    "/admin/inscricoes-teste",
    "/admin/inscricoes",
    "/admin/consultores/detalhes/:id",
    "/admin/consultores/criar",
    "/admin/consultores",
    "/admin/empresas",
    "/admin/relatorios/inscricoes/minificado",
    "/admin/relatorios/utm",
    "/admin/relatorios/espera",
    "/admin/relatorios/subitens",
    "/admin/blog/pocketbook4you/pocketDia",
    "/admin/blog/pocketbook4you",
    "/admin/blog/pocketbook4you/criar",
    "/admin/blog/pocketbook4you/detalhes/:lingua/:id",
    "/admin/blog/pocketbook4you/trilhas",
    "/admin/blog/pocketbook4you/trilhas/criar",
    "/admin/blog/pocketbook4you/trilhas/detalhes/:lingua/:id",
    "/admin/blog/pocketbook4you/usuarios",
    "/admin/blog/pocketbook4you/usuarios/detalhes/:id",
    "/admin/blog/pocketbook4you/parceiros/cadastro",
    "/admin/blog/pocketbook4you/parceiros/listagemsolicitacoesparceiros",
    "/admin/blog/pocketbook4you/parceiros/listagemsparceiros",
    "/admin/alunos/atribuir",
  ],
}; //pc

export const comercialUsers = {
  users: ["marcony.xavier@voitto.com.br"],
  routes: [
    "/admin",
    "/admin/empresas",
    "/admin/pocketbook/cupons",
    "/admin/pocketbook/cupons/criar",
    "/admin/pocketbook/cupons/detalhes/:id",
    "/admin/empresas/criar",
    "/admin/empresas/detalhes/:id",
    "/admin/empresas/solicitacoesEmpresas",
    "/admin/logsVoittoCoin",
    "/admin/logsVoittoCoin/detalhes/:id",
    "/admin/inscricoes",
    "/admin/inscricoes-teste",
    "/admin/parceiros",
    "/admin/pagamentos/gerar/:id_pessoa",
    "/admin/bandeiras_cart",
    "/admin/bandeiras_cart/criar",
    "/admin/bandeiras_cart/:id",
    "/admin/cupons",
    "/admin/cupons/relatorio",
    "/admin/cupons/criar",
    "/admin/cupons/:id",
    "/admin/relatorios/personalizacao",
    "/admin/analytic/cursos",
    "/admin/analytic/pessoas_cursos_status",
    "/admin/analytic/dados-absolutos",
    "/admin/analytic/dados-aluno-por-cursos",
    "/admin/alunos/voittocoins",
    "/admin/transferir_conta",
    "/admin/alunos/validade-curso",
    "/admin/controle_indicacoes/specials_vouchers",
    "/admin/logs",
    "/admin/logspagamento",
    "/admin/ame-pedidos",
    "/admin/ame-conciliacao",
    "/admin/pix-pedidos",
    "/admin/controle_indicacoes",
    "/admin/cabecalho-vendas",
    "/admin/relatorios/inscricoes",
    "/admin/relatorios/pesquisa",
    "/admin/relatorios/espera",
    "/admin/relatorios/inscricoes/minificado",
    "/admin/relatorios/utm",
    "/admin/relatorios/pacotes-vendidos",
    "/admin/relatorios/tickets",
    "/admin/pessoas_com_cursos_pagos",
    "/admin/pessoas_com_white_belt",
    "/admin/alunos",
    "/admin/alunos/validade-curso",
    "/admin/alunos/atribuir",
    "/admin/alunos/detalhes/:id",
    "/admin/pagamentos",
    "/admin/pagarme/planos",
    "/admin/pagarme/assinantes",
    "/admin/pagarme/assinante/:id_pessoa",
    "/admin/pagarme/inadimplentes",
    "/admin/faturas",
  ],
};

export const blogUsers = {
  users: ["renata.gazola@voitto.com.br"],
  routes: [
    "/admin",
    "/admin/relatorios",
    "/admin/pocketbook/cupons",
    "/admin/pocketbook/cupons/criar",
    "/admin/pocketbook/cupons/detalhes/:id",
    "/admin/relatorios/inscricoes",
    "/admin/relatorios/inscricoes/minificado",
    "/admin/relatorios/utm",
    "/admin/relatorios/espera",
    "/admin/relatorios/subitens",
    "/admin/relatorios/pacotes-vendidos",
    "/admin/relatorios/espera",
    "/admin/blog/pocketbook4you/pocketDia",
    "/admin/blog/pocketbook4you",
    "/admin/blog/pocketbook4you/criar",
    "/admin/blog/pocketbook4you/detalhes/:lingua/:id",
    "/admin/blog/pocketbook4you/trilhas",
    "/admin/blog/pocketbook4you/trilhas/criar",
    "/admin/blog/pocketbook4you/trilhas/detalhes/:lingua/:id",
    "/admin/blog/pocketbook4you/usuarios",
    "/admin/blog/pocketbook4you/usuarios/detalhes/:id",
    "/admin/blog/pocketbook4you/parceiros/cadastro",
    "/admin/blog/pocketbook4you/parceiros/listagemsolicitacoesparceiros",
    "/admin/blog/pocketbook4you/parceiros/listagemsparceiros",
  ],
};

export const consultorUsers = {
  users: ["raphaelcpnunes@gmail.com", "consultorEAD@voitto.com.br"],
  routes: [
    "/admin",
    "/admin/ead/duvidas",
    "/admin/operacoes",
    "/admin/ead/duvidas/editar/:idResposta",
  ],
};

export const formatDateToMySQL = (date) => {
  const pad = (number) => number.toString().padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // Os meses começam de 0 a 11
  const day = pad(date.getDate());

  return `${year}-${month}-${day}`;
};
//Blog

export function converterData(data) {
  const meses = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  // Divida a string da data em ano e mês
  const [ano, mes] = data.split("-");

  // Obtenha o nome do mês correspondente ao índice
  const nomeMes = meses[parseInt(mes) - 1];

  // Retorne a data no formato desejado
  return `${nomeMes}-${ano}`;
}
